<template>
  <div class="km-page">
    <header class="km-top">
      <button class="km-back" @click="back()" aria-label="Back">
        <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 18l-6-6 6-6"/></svg>
      </button>
      <div class="km-top__title"><span class="km-top__dot"></span><h1>{{ $t('my.my_statement') }}</h1></div>
      <div style="width:38px"></div>
    </header>

    <main class="km-main">
      <section class="km-section">
        <!-- Hero — net P&L -->
        <div class="kpr-hero" :class="{ 'kpr-hero--neg': win_money < 0 }">
          <div class="kpr-hero__glow"></div>
          <div class="kpr-hero__lbl">{{ $t('withdraw.task_money') }} · {{ $t('reservation.unit') }}</div>
          <div class="kpr-hero__val">
            <span class="kpr-hero__sign">{{ win_money >= 0 ? '+' : '' }}</span>
            <span class="kpr-hero__num">{{ win_money.toFixed(2) }}</span>
          </div>
          <div class="kpr-hero__sub">{{ $t('reservation.win_formula') }}</div>
        </div>
      </section>

      <section class="km-section">
        <div class="km-sec-head">Breakdown</div>
        <div class="kpr-grid">
          <div class="kpr-stat kpr-stat--pink">
            <span class="kpr-stat__emoji">🎯</span>
            <span class="kpr-stat__val">{{ personalreport.play_money || 0 }}</span>
            <span class="kpr-stat__lbl">{{ $t('withdraw.task_money') }}</span>
          </div>
          <div class="kpr-stat kpr-stat--green">
            <span class="kpr-stat__emoji">📥</span>
            <span class="kpr-stat__val">{{ personalreport.recharge || 0 }}</span>
            <span class="kpr-stat__lbl">{{ $t('withdraw.recharge_money') }}</span>
          </div>
          <div class="kpr-stat kpr-stat--orange">
            <span class="kpr-stat__emoji">📤</span>
            <span class="kpr-stat__val">{{ personalreport.withdrawal || 0 }}</span>
            <span class="kpr-stat__lbl">{{ $t('withdraw.money') }}</span>
          </div>
          <div class="kpr-stat kpr-stat--purple">
            <span class="kpr-stat__emoji">🏆</span>
            <span class="kpr-stat__val">{{ personalreport.win_money || 0 }}</span>
            <span class="kpr-stat__lbl">{{ $t('withdraw.win_money') }}</span>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
export default {
  data() { return { win_money: 0, personalreport: {} }; },
  methods: {
    back() { return window.history.back(); },
    getPersonalreport() {
      this.$http({ method: 'get', url: 'user_get_personalreport' }).then(res => {
        if (res.code === 200) {
          this.personalreport = res.data;
          this.win_money = this.personalreport.win_money - this.personalreport.play_money;
        } else if (res.code === 401) this.$toast(res.msg);
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) this.$router.push({ path: '/Login' });
    else this.getPersonalreport();
  }
};
</script>

<style lang="less" scoped>
@import "./_km-page.less";

.kpr-hero {
  position: relative; overflow: hidden;
  background: linear-gradient(135deg, #1a1033 0%, #4a1a6e 100%);
  color: #fff; border-radius: 18px; padding: 22px 20px;
  box-shadow: 0 14px 36px rgba(74,26,110,.25);
  text-align: center;
}
.kpr-hero__glow {
  position: absolute; inset: 0;
  background:
    radial-gradient(circle at 20% 0%, rgba(255,77,141,.4), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(160,32,240,.4), transparent 55%);
  pointer-events: none;
}
.kpr-hero--neg .kpr-hero__glow {
  background:
    radial-gradient(circle at 20% 0%, rgba(239,68,68,.35), transparent 55%),
    radial-gradient(circle at 100% 100%, rgba(244,63,94,.35), transparent 55%);
}
.kpr-hero__lbl { position: relative; font-size: 12px; opacity: .85; font-weight: 600; letter-spacing: .05em; text-transform: uppercase; }
.kpr-hero__val { position: relative; display: flex; align-items: baseline; justify-content: center; gap: 4px; margin: 8px 0 4px; }
.kpr-hero__sign { font-size: 22px; opacity: .9; font-weight: 700; }
.kpr-hero__num { font-size: 40px; font-weight: 800; letter-spacing: -.02em; text-shadow: 0 4px 16px rgba(0,0,0,.2); }
.kpr-hero__sub { position: relative; font-size: 12px; opacity: .75; line-height: 1.4; padding: 0 10px; }

.kpr-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.kpr-stat {
  position: relative; overflow: hidden;
  background: linear-gradient(180deg, #fff 0%, #fff6fa 100%);
  border-radius: 14px; padding: 16px 14px;
  border: 1px solid rgba(255,77,141,.12);
  box-shadow: 0 6px 18px rgba(255,77,141,.08), inset 0 1px 0 rgba(255,255,255,.9);
  text-align: center;
}
.kpr-stat::before {
  content: ''; position: absolute; top: -20px; right: -20px;
  width: 80px; height: 80px; border-radius: 50%;
  opacity: .15; pointer-events: none;
}
.kpr-stat--pink::before   { background: radial-gradient(circle, #ff4d8d, transparent 70%); }
.kpr-stat--green::before  { background: radial-gradient(circle, #10b981, transparent 70%); }
.kpr-stat--orange::before { background: radial-gradient(circle, #f59e0b, transparent 70%); }
.kpr-stat--purple::before { background: radial-gradient(circle, #a020f0, transparent 70%); }
.kpr-stat__emoji { font-size: 22px; display: block; margin-bottom: 6px; }
.kpr-stat__val {
  display: block; font-size: 22px; font-weight: 800; letter-spacing: -.01em;
  color: #2a1a3f; margin-bottom: 2px;
}
.kpr-stat__lbl { display: block; font-size: 11px; color: #8273a0; font-weight: 600; letter-spacing: .03em; text-transform: uppercase; }
</style>
